import { alpha, type Theme } from '@mui/material/styles'

export const attentionBorderPulseSx = (
  theme: Theme,
  color: 'primary' | 'secondary',
  options?: { iterations?: number | 'infinite' }
) => {
  const palette = theme.palette[color]
  const keyframeName = `attentionBorderPulse-${color}`
  const iterations = options?.iterations ?? 8

  return {
    [`@keyframes ${keyframeName}`]: {
      '0%, 100%': {
        borderColor: palette.main,
        boxShadow: 'none'
      },
      '50%': {
        borderColor: palette.dark,
        boxShadow: `0 0 0 3px ${alpha(palette.main, 0.3)}`
      }
    },
    animation: `${keyframeName} 1.4s ease-in-out ${iterations}`,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none'
    }
  }
}
